import { notification } from "antd";

export const openNotifcation = (type, message, description) => {
  notification[type]({
    message,
    description,
  });
};
